/* specifically target IE11 */
/* controlled focus outline */
/**
 * AGL BRAND TOKENS VERSION 0.2.45
 * GENERATED BY STYLE DICTIONARY
 * DO NOT EDIT THIS FILE DIRECTLY
 */
/* usage
.selector {
  color: red;

  @include breakpoint(sm) {
    color: blue;
  }
}
*/
.dls-fontfamily01 {
  font-family: "Titillium Web", sans-serif !important;
}

.dls-fontfamily02 {
  font-family: "Open Sans", sans-serif !important;
}

.dls-default-colour {
  color: var(--colors-component-typography-enabled);
}

.dls-muted-colour {
  color: var(--colors-component-typography-muted);
}

.dls-highlight-colour {
  color: var(--colors-component-primary-01);
}

.dls-inverse-colour {
  color: var(--colors-component-typography-inverse-enabled);
}

.dls-highlight-secondary-colour {
  color: var(--colors-component-typography-secondary-highlight);
}

.dls-error-colour {
  color: var(--colors-component-typography-error);
}

:host :host {
  display: block;
}
:host .dls-title1 {
  font-family: "Titillium Web", sans-serif;
  font-weight: 300;
  letter-spacing: 0;
  margin-top: 32px;
}
@media (min-width: 0) {
  :host .dls-title1 {
    line-height: 3.125rem;
    font-size: 2.5rem;
  }
}
@media (min-width: 720px) {
  :host .dls-title1 {
    line-height: 3.4375rem;
    font-size: 2.75rem;
  }
}
@media (min-width: 992px) {
  :host .dls-title1 {
    line-height: 3.75rem;
    font-size: 3rem;
  }
}
:host .dls-title2 {
  font-family: "Titillium Web", sans-serif;
  font-weight: 300;
  letter-spacing: 0;
  margin-top: 32px;
}
@media (min-width: 0) {
  :host .dls-title2 {
    line-height: 2.1875rem;
    font-size: 1.75rem;
  }
}
@media (min-width: 720px) {
  :host .dls-title2 {
    line-height: 2.5rem;
    font-size: 2rem;
  }
}
@media (min-width: 992px) {
  :host .dls-title2 {
    line-height: 2.8125rem;
    font-size: 2.25rem;
  }
}
:host .dls-title3 {
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  letter-spacing: 0;
  margin-top: 32px;
}
@media (min-width: 0) {
  :host .dls-title3 {
    line-height: 1.875rem;
    font-size: 1.5rem;
  }
}
@media (min-width: 720px) {
  :host .dls-title3 {
    line-height: 2.03125rem;
    font-size: 1.625rem;
  }
}
@media (min-width: 992px) {
  :host .dls-title3 {
    line-height: 2.1875rem;
    font-size: 1.75rem;
  }
}
:host .dls-title4 {
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  letter-spacing: 0;
  margin-top: 32px;
}
@media (min-width: 0) {
  :host .dls-title4 {
    line-height: 1.71875rem;
    font-size: 1.375rem;
  }
}
@media (min-width: 720px) {
  :host .dls-title4 {
    line-height: 1.875rem;
    font-size: 1.5rem;
  }
}
@media (min-width: 992px) {
  :host .dls-title4 {
    line-height: 1.875rem;
    font-size: 1.5rem;
  }
}
:host .dls-title5 {
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  letter-spacing: 0;
  margin-top: 32px;
}
@media (min-width: 0) {
  :host .dls-title5 {
    line-height: 1.5625rem;
    font-size: 1.25rem;
  }
}
@media (min-width: 720px) {
  :host .dls-title5 {
    line-height: 1.5625rem;
    font-size: 1.25rem;
  }
}
@media (min-width: 992px) {
  :host .dls-title5 {
    line-height: 1.5625rem;
    font-size: 1.25rem;
  }
}
:host .dls-title6 {
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  letter-spacing: 0;
  margin-top: 32px;
}
@media (min-width: 0) {
  :host .dls-title6 {
    line-height: 1.40625rem;
    font-size: 1.125rem;
  }
}
@media (min-width: 720px) {
  :host .dls-title6 {
    line-height: 1.40625rem;
    font-size: 1.125rem;
  }
}
@media (min-width: 992px) {
  :host .dls-title6 {
    line-height: 1.40625rem;
    font-size: 1.125rem;
  }
}
:host .dls-top-margin--none {
  margin-top: 0;
}
:host .dls-top-margin--space00 {
  margin-top: 4px;
}
:host .dls-top-margin--space01 {
  margin-top: 8px;
}
:host .dls-top-margin--space02 {
  margin-top: 16px;
}
:host .dls-top-margin--space03 {
  margin-top: 24px;
}
:host .dls-top-margin--space04 {
  margin-top: 32px;
}
:host .dls-top-margin--space05 {
  margin-top: 40px;
}
:host .dls-top-margin--space06 {
  margin-top: 48px;
}